module.exports = __webpack_public_path__ + "static/media/season_2.53a76920.png";